import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/payments/_layout/')({
  component: () => null,
});
